export const loadFonts = fontUrls => {
  fontUrls.forEach(url => {
    if (!document.querySelector(`link[href="${url}"]`)) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = url
      link.display = 'swap'
      document.head.appendChild(link)
    }
  })
}

// font presets
export const FONTS = {
  lander13: [
    'https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;500;600;700&display=swap',
    'https://fonts.googleapis.com/css2?family=Nunito+Sans:opsz,wght@6..12,400;6..12,500;6..12,600;6..12,700&display=swap',
    'https://fonts.googleapis.com/css2?family=Titillium+Web:wght@400;600;700&display=swap',
  ],
  lander14: [
    'https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700&display=swap',
  ],
  lander15: [
    'https://fonts.googleapis.com/css2?family=Syne:wght@400;500;600;700&display=swap',
  ],
  lander17: [
    'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap',
    'https://fonts.googleapis.com/css2?family=Quicksand&display=swap',
  ],
  signupAff: [
    'https://fonts.googleapis.com/css2?family=Gothic+A1:wght@400;500;600;700&display=swap',
    'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap',
  ],
  creditsCard: [
    'https://fonts.googleapis.com/css2?family=Jost:wght@400;500;600;700&display=swap',
  ],
}
